<template>
	<div>
		<person-header :fetched-data="fetchedData" />
		<article>
			<header class="lecturer-header theme-light">
				<div class="container">
					<div class="row align-items-lg-center">
						<div class="col-12 col-md-4 col-lg-3">
							<div class="lecturer-image">
								<img :src="fetchedData.square_photo" :alt="fetchedData.title">
							</div>
						</div>
						<div class="col-12 col-md-8 col-lg-8 offset-lg-1">
							<div class="row">
								<div class="col-12 col-lg-9">
									<div class="lecturer-title-block">
										<!--<div class="tag_string">
											<span>Преподаватель</span>
											<span>Инвестирование</span>
										</div>-->
										<div class="breadcrumbs-block">
											<ol v-if="fetchedData.language === 'en'" class="breadcrumb">
												<!--<li class="breadcrumb-item">
													<a :href="'/en/'">{{ $t('pages.home') }}</a>
												</li>-->
												<li class="breadcrumb-item">
													<a :href="'/en/academic/academic-faculty/'">{{ $t('professors') }}</a>
												</li>
											</ol>
											<ol v-else class="breadcrumb">
												<!--<li class="breadcrumb-item">
													<a :href="'/'">{{ $t('pages.home') }}</a>
												</li>-->
												<li class="breadcrumb-item">
													<a :href="'/academic/academic-faculty/'">{{ $t('professors') }}</a>
												</li>
											</ol>
										</div>

										<h1>{{ fetchedData.title }}</h1>
										<div class="description">
											{{ fetchedData.job_title }}
										</div>
									</div>
								</div>
								<div class="col-12 col-lg-3">
									<ul v-if="fetchedData.primary_logos !==null" class="lecturer-header-partners">
										<li v-for="(item, index) in fetchedData.primary_logos" :key="index">
											<img :src="item.src" alt>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
			<line-menu :links="absoluteLinks" />

			<div
				v-if="templates.includes('content') && !components.includes('panel-announces')"
				class="article-content"
			>
				<div class="container">
					<div class="row">
						<div class="col-12 col-lg-3 sticky-container">
							<div class="content-info">
								<div class="row">
									<div class="col-12 col-md-12 col-lg-12">
										<!-- <button class="btn btn-primary mb-4">Задать вопрос преподавателю</button> -->
										<div class="lecturer-personal">
											<!-- <div class="subtitle">Контакты</div> -->
											<div class="row">
												<div
													v-if="fetchedData.person_info?.education"
													class="col-12 col-md-6 col-lg-12"
												>
													<div class="subtitle">
														{{ $t('education') }}
													</div>
													<p
														v-for="(item, index) in fetchedData.person_info?.education"
														:key="index"
													>
														<b>{{ item.academic_degree }}</b>{{ item.institute ? `, ${item.institute}` : '' }}
													</p>
												</div>

												<div class="col-12 col-md-6 col-lg-12">
													<div
														v-if="
															fetchedData.telegram
																|| fetchedData.vkontakte
																|| fetchedData.twitter
																|| fetchedData.phone
																|| fetchedData.email
																|| fetchedData.website"
														class="subtitle"
													>
														{{ $t('contacts') }}
													</div>
													<div
														v-if="
															fetchedData.telegram
																//	fetchedData.facebook
																|| fetchedData.vkontakte
																|| fetchedData.twitter

																//	|| fetchedData.instagram
																//	|| fetchedData.linkedin
																|| fetchedData.phone
																|| fetchedData.email
																|| fetchedData.website"
														class="share"
													>
														<div class="share_list">
															<a
																v-if="fetchedData.vkontakte"
																:href="fetchedData.vkontakte"
																target="_blank"
																class="icon-vk btn btn-primary"
															/>
															<a
																v-if="fetchedData.twitter"
																:href="fetchedData.twitter"
																target="_blank"
																class="icon-twitter btn btn-primary"
															/>
															<a
																v-if="fetchedData.telegram"
																:href="fetchedData.telegram"
																target="_blank"
																class="icon-telegram btn btn-primary"
															/>
															<a
																v-if="fetchedData.email"
																:href="'mailto:' + fetchedData.email"
																class="icon-mail btn btn-primary"
															>
																{{ fetchedData.email }}
															</a>
														</div>
													</div>

													<ul
														v-if="fetchedData.phone || fetchedData.website"
														class="lecturer-contacts"
													>
														<li v-if="fetchedData.phone">
															<a :href="'tel:' + fetchedData.phone" class="icon-phone">{{
																fetchedData.phone }}</a>
														</li>
														<li v-if="fetchedData.website">
															<a
																:href="fetchedData.website"
																class="icon-www"
																target="_blank"
																rel="noopener noreferrer"
															>{{ fetchedData.website }}</a>
														</li>
													</ul>
													<div class="subtitle">
														<a
															v-if="fetchedData.cv_file"
															:href="fetchedData.cv_file"
															class="btn btn-primary mb-4"
															target="_blank"
														>
															{{ $t('download') }} CV
														</a>

														<a
															v-if="fetchedData.bio"
															:href="fetchedData.bio"
															:download="fetchedData.bio"
															class="btn btn-primary mb-4"
															target="_blank"
														>
															{{ $t('download') }} {{ $t('bio') }}
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div
										v-if="fetchedData.secondary_logos?.length > 0"
										class="col-12 col-md-12 col-lg-12"
									>
										<div class="subtitle">
											При поддержке:
										</div>
										<ul class="lecturer-partners">
											<li v-for="(item, index) in fetchedData.secondary_logos" :key="index">
												<img :src="item.src" alt>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>

						<div class="col-12 col-lg-8 offset-lg-1">
							<div class="page-content">
								<div
									v-if="fetchedData.person_info?.disciplines?.length
										&& templates.includes('taxonomy-collapse')"
									class="block-bio"
								>
									<div class="row">
										<div class="col-12 col-lg-3">
											<div class="subtitle">
												{{ $t('disciplines') }}
											</div>
										</div>
										<div class="col-12 col-lg-9">
											<div class="border-lg-top pt-lg-4 mb-5">
												<div class="subjects-accordion">
													<div
														v-for="(navItem,i) in fetchedData.person_info.disciplines"
														:key="i"
														class="nav-item"
													>
														<div
															data-toggle="collapse"
															role="button"
															:aria-expanded="navItem.expand"
															aria-controls="sidebar-products"
															@click.prevent="navItemCollapse(i)"
														>
															<div class="mb-2">
																<b
																	v-if="$i18n.locale === 'ru'"
																	class="nav-link-text"
																>
																	{{ navItem.ru.name }}
																</b>
																<b
																	v-if="$i18n.locale === 'en'"
																	class="nav-link-text"
																>
																	{{ navItem.en.name }}
																</b>
															</div>
														</div>
														<div
															v-if="navItem.topics?.length >0"
															class="collapse"
															:class="{show: navItem.expand}"
														>
															<div
																class="nav nav-sm flex-column"
															>
																<div
																	v-for="(subItem, j) in navItem.topics"
																	:key="j"
																	class="nav-item"
																>
																	<div class="mb-2">
																		<span
																			v-if="$i18n.locale === 'ru'"
																			class="nav-link-text"
																		>
																			{{ subItem.ru.name }}
																		</span>
																		<span
																			v-if="$i18n.locale === 'en'"
																			class="nav-link-text"
																		>
																			{{ subItem.en.name }}
																		</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									v-if="fetchedData.description && templates.includes('biography')"
									id="bio"
									class="block-bio"
								>
									<div class="row">
										<div class="col-12 col-lg-3">
											<div class="subtitle">
												{{ $t('biography') }}
											</div>
										</div>
										<div class="col-12 col-lg-9 border-lg-top">
											<div class="content pt-4" v-html="fetchedData.description" />
										</div>
									</div>
								</div>
								<div
									v-for="(block, index) in fetchedData.blocks"
									v-if="templates.includes('biography')"
									:key="index"
								>
									<component
										:is="block.type"
										v-if="components.includes(block.type)"
										:ref="block.type"
										:index="index"
										:block="block"
										:content="block.content"
										:fetched-data="fetchedData"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</article>

		<!-- Версточный блок (ключевые публикации) -->
		<panel-publications
			v-if="components.includes('panel-publications')"
			:person-slug="fetchedData.slug"
			:name-genitive="fetchedData.name_genitive"
		/>

		<div v-if="components.includes('panel-publications-sources') && contentSources.length" class="panel">
			<div class="container">
				<div class="panel_header">
					<h2>Источники</h2>
				</div>
				<div class="partners-block">
					<ul class="partners-list row">
						<li v-for="source in contentSources" class="col-6 col-sm-4 col-md-3 col-lg-2">
							<div class="partner">
								<div class="logo">
									<img :src="source.logo?.src" alt="">
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div v-if="components.includes('panel-sources-strings') && sourcesString" class="panel">
			<div class="container">
				<div class="panel_header">
					<h2>Источники:</h2>
					<div class="sources-list">
						{{ sourcesString }}
					</div>
				</div>
			</div>
		</div>

		<!--Тут не страшно, что id'шник повторяются,
			т.к. в блоке выше они используются в противоположном условии.
		Применить v-else не получится, т.к. это ломает верстку-->
		<div v-if="!templates.includes('content') && !components.includes('panel-announces')" class="article-content">
			<div v-if="disciplines.length > 0 && templates.includes('taxonomy')" class="container">
				<div id="taxonomy" class="block-bio">
					<div class="panel_header">
						<div class="row align-items-end">
							<div class="col-12 col-lg-12">
								<h2>{{ $t('disciplines') }}</h2>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-9">
						<div v-for="discipline in disciplines" :key="discipline.title" class="content">
							<p>
								<strong>{{ discipline.title }}</strong>
							</p>
						</div>
					</div>
				</div>
			</div>

			<div v-if="fetchedData.description && templates.includes('biography')" class="container">
				<div id="bio" class="block-bio">
					<div class="panel_header">
						<div class="row align-items-end">
							<div class="col-12 col-lg-12">
								<h2>{{ $t('biography') }}</h2>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-9">
						<div class="content" v-html="fetchedData.description" />
					</div>
				</div>
			</div>

			<div v-for="(block, index) in fetchedData.blocks" :key="index">
				<component
					:is="block.type"
					v-if="components.includes(block.type)"
					:ref="block.type"
					:index="index"
					:block="block"
					:content="block.content"
					:fetched-data="fetchedData"
					:static_content="block.static_content"
					:block_title="block.block_title"
				/>
			</div>
		</div>

		<event-navigator-items
			v-if="hasPanelEventsFuture && fetchedData.events_future?.length !== 0"
			:items="fetchedData.events_future"
			:title="'Анонсы мероприятий с участием ' + (fetchedData.name_genitive ? fetchedData.name_genitive : 'преподавателя')"
		/>

		<event-navigator-items
			v-if="hasPanelEventsPast && fetchedData.events_past?.length !== 0"
			:items="fetchedData.events_past"
			:title="'Прошедшие мероприятия с участием ' + (fetchedData.name_genitive ? fetchedData.name_genitive : 'преподавателя')"
		/>

		<programs-navigator-items
			v-if="hasPanelProgramsFuture && fetchedData.programs_future?.length !== 0"
			:items="fetchedData.programs_future"
			:title="'Программы с участием ' + (fetchedData.name_genitive ? fetchedData.name_genitive : 'преподавателя')"
		/>

		<programs-navigator-items
			v-if="hasPanelProgramsPast && fetchedData.programs_past?.length !== 0"
			:items="fetchedData.programs_past"
			:title="'Прошедшие программы с участием ' + (fetchedData.name_genitive ? fetchedData.name_genitive : 'преподавателя')"
		/>

		<!-- это временный блок-->
		<author-issue-useful-content v-if="components.includes('author-content')" :author="fetchedData" />

		<!--<feedback-form :author="fetchedData" />-->
		<main-footer />
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import ucFirst from '~/utils/ucFirst';
import { denormalizeUrl, normalizeUrl } from '~/utils/urlHelper';
import panels from '~/mixins/panels';
import createJivoMixin from '~/mixins/createJivoMixin';
import HtmlRaw from '~/components/refactor/HtmlRaw.vue';
import LineMenu from '~/components/layouts/_partials/LineMenu.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import PersonHeader from '~/components/layouts/headers/PersonHeader.vue';
import PanelPublications from '~/components/dev/PanelPublications.vue';
import EventNavigatorItems from '~/components/refactor/EventNavigatorItems.vue';
import ProgramsNavigatorItems from '~/components/refactor/ProgramsNavigatorItems.vue';
import EventStars from '~/components/refactor/EventStars.vue';
import makeCanonicalLink from '~/utils/seo/makeCanonicalLink';
import AuthorIssueUsefulContent from './components/AuthorIssueUsefulContent.vue';
import FeedbackForm from './components/FeedbackForm.vue';
import links from './links';

export default {
	name: 'LecturerPage',
	components: {
		LineMenu,
		PersonHeader,
		HtmlRaw,
		MainFooter,
		Swiper,
		SwiperSlide,
		AuthorIssueUsefulContent,
		FeedbackForm,
		EventNavigatorItems,
		ProgramsNavigatorItems,
		PanelPublications,
		EventStars,
	},
	directives: {
		swiper: directive,
	},
	mixins: [panels, createJivoMixin()],
	async asyncData({ app, params, route }) {
		const { $pagesApi } = app;
		const { slug } = params;
		const { path } = route;
		const is_professor = path.split('/')[1] !== 'management' ? 1 : 0;
		const lang = route.fullPath.split('/').includes('en') ? 'en' : 'ru';
		return {
			fetchedData: await $pagesApi.person(slug, lang, { is_professor }),
		};
	},
	data() {
		return {
			fetchedData: {},
			contentSources: [],
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				cssMode: true,
				// freeMode: true,
				loop: false,
			},
			isSectionsCollapse: true,
			links,
			innerPageId: null, // id текущей страницы в links. На основе id формируются components и templates
		};
	},
	head() {
		const title = this.links[this.innerPageId]?.name
			? `${this.fetchedData.title}: ${this.$t(this.links[this.innerPageId].name)}`
			: this.fetchedData.title;
		return {
			title,
			link: [
				{
					rel: 'canonical',
					hid: 'canonical',
					href: makeCanonicalLink(this.$route.path),
				},
			],
			meta: [
				{
					name: 'description',
					hid: 'description',
					content: this.fetchedData.job_title,
				},
				// Open Graph
				{
					name: 'og:title',
					hid: 'og:title',
					content: this.fetchedData.title,
				},
				{
					name: 'og:description',
					hid: 'og:description',
					content: this.fetchedData.job_title,
				},
				{
					name: 'og:type',
					hid: 'og:type',
					content: 'article',
				},
				{
					name: 'og:image',
					hid: 'og:image',
					content: this.fetchedData.square_photo,
				},
				// Twitter Card
				{
					name: 'twitter:card',
					content: 'summary',
				},
				{
					name: 'twitter:site',
					content: '@nuxt_js',
				},
				{
					name: 'twitter:title',
					content: this.fetchedData.title,
				},
				{
					name: 'twitter:description',
					content: this.fetchedData.job_title,
				},
				{
					name: 'twitter:image',
					content: this.fetchedData.square_photo,
				},
				{
					name: 'image',
					property: 'og:image',
					content: this.fetchedData.square_photo,
				},
				{
					name: 'author',
					content: 'SKOLKOVO',
				},
			],
		};
	},
	computed: {
		disciplines() {
			return this.fetchedData?.person_info?.subjects || [];
		},
		hasPanelEventsFuture() {
			return (
				this.components.includes('panel-announces')
				&& this.fetchedData?.events_future?.length
			);
		},
		hasPanelEventsPast() {
			return (
				this.components.includes('panel-announces')
				&& this.fetchedData?.events_past?.length
			);
		},
		hasPanelProgramsFuture() {
			return (
				this.components.includes('panel-programs')
				&& this.fetchedData?.programs_future?.length
			);
		},
		hasPanelProgramsPast() {
			return (
				this.components.includes('panel-programs')
				&& this.fetchedData?.programs_past?.length
			);
		},
		publicationsCount() {
			return this.fetchedData?.publications || 0;
		},
		hasPublications() {
			if (this.links[2].active === true) return true;
			return false;
		},
		hasPrograms() {
			return !!this.fetchedData.programs_future?.length || !!this.fetchedData.programs_past?.length;
		},
		hasEvents() {
			return !!this.fetchedData.events_future?.length || !!this.fetchedData.events_past?.length;
		},
		hasContent() {
			return !!this.fetchedData.blocks?.length || this.getComponent;
		},
		absoluteLinks() {
			// узнаем, содержит ли текущий путь innerSlug и получаем урл без innerSlug (т.е. "базовый урл")
			let pathWithoutInnerSlug = denormalizeUrl(this.$route.fullPath);
			const pathSplitArr = pathWithoutInnerSlug.split('/');

			if (pathSplitArr[pathSplitArr.length - 1] === this.$route.params.innerSlug) {
				const countRemovedChars = this.$route.params.innerSlug?.length;
				pathWithoutInnerSlug = pathWithoutInnerSlug.slice(
					0,
					-countRemovedChars,
				);
			}

			// фильтруем по наличию контента
			const filtredLinks = this.links?.filter((e) => {
				if (e.name === 'events') {
					return this.hasEvents;
				}

				if (e.name === 'programs') {
					return this.hasPrograms;
				}

				if (e.name === 'publications') {
					return this.hasPublications;
				}

				if (e.name === 'photoVideo') {
					return this.hasContent;
				}

				return true;
			});

			// добавляем в базовый урл новый innerSlug
			return filtredLinks?.map((e) => {
				const basicPath = denormalizeUrl(pathWithoutInnerSlug);
				const innerSlug = normalizeUrl(e.innerSlug);
				e.path = `${basicPath}${innerSlug}`;
				return e;
			});
		},
		components() {
			return this.links[this.innerPageId]?.components || [];
		},
		getComponent() {
			const a = this.links.find((element) => element.name === 'photoVideo');
			return !!a.name;
		},
		templates() {
			return this.links[this.innerPageId]?.templates || [];
		},
		sourcesString() {
			if (typeof this.contentSources !== 'object' || this.contentSources === null) return '';
			const sources = Array.isArray(this.contentSources) ? this.contentSources : Object.values(this.contentSources);

			return this.ucFirst(sources.map((str) => {
				if (!str) return '';
				return str.toLowerCase();
			}).join(', '));
		},
	},
	watch: {
		'$route.params.innerSlug': {
			handler(innerSlug) {
				let innerPageId = 0;

				this.links.forEach((link, index) => {
					if (!innerPageId && link.home) innerPageId = index;
					if (denormalizeUrl(link.innerSlug) === innerSlug) innerPageId = index;
				});

				this.innerPageId = innerPageId;
			},
			immediate: true,
		},
		fetchedData: {
			handler(value) {
				if (value && value.language) {
					this.$i18n.setLocale(value.language);
				}
			},
		},
	},
	methods: {
		ucFirst,
		topicsToString(topics) {
			return ucFirst(topics.map(({ title }) => title).join(', '));
		},
		navItemCollapse(index) {
			this.fetchedData.person_info.disciplines = this.fetchedData.person_info.disciplines.map((item, i) => {
				item.expand = !item.expand;
				if (i !== index) {
					item.expand = false;
				}
				return item;
			});
		},
	},
};
</script>

<style style lang="scss" scoped>
	// panel-announces - временно, для поддержки стилей
	@import "/assets/styles/components/home/panel-announces";

	@import "/assets/styles/components/home/event-menu";
	@import "/assets/styles/components/home/panel-partners-list";
	@import "/assets/styles/components/dev/lecturer";

	.sources-list {
	font-size: 1.5rem;
	}
</style>
